import { ProctorRequestDetailsSection } from '@exam-center/proctor-request-details';
import { Flex } from '@shared/components';

export default function ProctorRequestDetailPage() {
  return (
    <Flex sx={(theme) => ({ flex: 1, flexDirection: 'column', padding: theme.spacing(6) })}>
      <ProctorRequestDetailsSection />
    </Flex>
  );
}
